import Badge from '@components/Badge';
import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { OrderLogRow } from '@models/order/orderLog';
import { Link } from '@stackflow/link';
import { pressActionEffect } from '@styles/mixin';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

interface Props {
    order: OrderLogRow;
}

function OrderLog({ order }: Props) {
    const { t } = useTranslation('orderLogs');
    const {
        status, shopName, orderName, optionSummary, createdAt, orderNo, shopOrderNo, orderType,
        displayOrderNo,
    } = order;
    return (
        <Link activityName='OrderLogActivity'
            activityParams={{ orderNo }}
            css={[pressActionEffect, wrapperCss]} >
            <Container spacing={4}
                fullWidth>
                <Body spacing={12}
                    fullWidth >
                    <Badge variant='outline' color={status === 'READY' ? colors.primary : colors.gray6}>
                        {t(`status.${status}`)}
                    </Badge>
                    <Text fontWeight='bold' size='xl'>{shopName}</Text>
                    <ItemText color={colors.gray7}>
                        {t(`orderType.${orderType}`)} {(displayOrderNo || `${shopOrderNo}`).padStart(4, '0')} ·
                      &nbsp;{orderName} {optionSummary}
                    </ItemText>
                </Body>
                <Footer>
                    <Text color={colors.gray6} align='center'>
                        {dayjs(createdAt).format('YYYY.MM.DD')}
                    </Text>
                </Footer>
            </Container>
        </Link>
    );
}

const wrapperCss = css`
    width: 100%;
`;

const Container = styled(Column)`
    border: 1px solid var(--color-gray3);
    border-radius: 8px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
`;

const Body = styled(Column)`
    padding: 16px;
    overflow: hidden;
`;

const Footer = styled.div`
    border-top: 1px solid var(--color-gray3);
    padding: 8px 0;
    text-align: center;
    width: 100%;
`;

const ItemText = styled(Text)`
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export default OrderLog;
